
// 顧客詳細画面の入庫前確認タブ（緑）、概算見積タブ（赤）で使用
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputString from "@/components/common/input/InputString.vue";

import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { UserService } from "@/service/UserService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { SocketControllers } from "@/service/SocketControllers";
import { INSPECT_TYPE } from "@/model/InspectType";
import { SeibiItem } from "@/model/InspectionSeibi";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import QuickInspectionCostComponent from "@/components/QuickInspectionCostComponent.vue";
import QuickInspectListComponent from "@/components/QuickInspectListComponent.vue";
import QuickMitsumoriContentPreview from "@/components/QuickMitsumoriContentPreview.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import QuickOptionComponentNex from "@/components/QuickOptionComponentNex.vue";
import EstimatePreview from "@/components/EstimatePreview.vue";
import EstimateDetail from "@/page/factory/estimateDetail.vue";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";
import { InspectionJizenDetailStoreService } from "@/service/InspectionJizenDetailStoreService";

const namespace: string = "ReservationDetail";

@Component({
  components: {
    InputNumber,
    InputString,
    ConfirmDialog
    , EstimateListComponent
    , EstimateInspectionCostComponent
    , QuickInspectionCostComponent
    , QuickInspectListComponent
    , QuickMitsumoriContentPreview
    , QuickCouponComponent
    , QuickOptionComponent
    , QuickOptionComponentNex
    , EstimatePreview
  },
  filters: {
    Number
  }
})
export default class EstimateDetailContent extends EstimateDetail {

  isModeTab: boolean = true;
  isModeQuick: boolean = false;

  @Prop() standby: number;
  @Getter("uketsukeExtendsId", { namespace })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace })
  yoyakuNo: string;

  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [END] */

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */
  @Getter("isEstimateBuhin", { namespace: "FunctionSetting" })
  isEstimateBuhin: any;


  @Getter("freeOfChargeLabelMini", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  inspectionDetailStoreService1: InspectionShakenShuruiDetailStoreService =
    new InspectionShakenShuruiDetailStoreService();
  inspectionDetailStoreService2: InspectionJizenDetailStoreService = new InspectionJizenDetailStoreService();

  data: any = {};
  reqService: requestService;
  ippanSeibiService: IppanSeibiService;
  sktControll: SocketControllers;
  isUserMode: boolean = false;

testmode: boolean = false; // 部品詳細展開

  seibiList: any = [];

  showDialogEstimate: boolean = false;
  estData: any = {};
  inspectType: number = INSPECT_TYPE.RECOMMEND;
  estIssueAt: string = "";

  execAfOpenShowTax: boolean = false;
  execAfOpenUpdateShohiyou: boolean = false;
  execAfOpenUpdateEstimate: boolean = false;

  loading: boolean = false;
  loadingText: string = MESSAGE.Loading; 
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
  // loadingShakenShurui: boolean = false;
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */

  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  timeId: any = null;
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */

  isExitConnectSocket: boolean = false;

  $refs!: {
    estimateInspectionCostComponent: EstimateInspectionCostComponent;
    quickInspectionCostComponent: QuickInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    quickOptionComponentNex: QuickOptionComponentNex;
    estimateListComponent: EstimateListComponent;
    dialog: ConfirmDialog;
    confirmDialogOnlyClose: ConfirmDialog;
    /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
    updateShakenShuruiDialog: ConfirmDialog;
    /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */
    saveAndExitDialog: ConfirmDialog;
  };
  public utils: Utils = new Utils();

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.onReconnect(() => this.selectionReceiver.receive());
    ["updateCourseSubscription", "inspectSubscriptionDetail", "couponSubscription", "optionSubscription"]
      .forEach(key => this.sktControll.socketEntry(key, this.onSelectionChanged));
    if (this.isCanJizenMitsumori) {
      /** やりたいことは、再読込なので、流用する */
      this.sktControll.socketEntry("estimateListSubscription",this.onPayments); // catchSocket:ソケット仮01
      this.sktControll.socketEntry("ak7Subscribe",this.onPayments); // catchSocket:ソケット仮34

      // catchSocket:ソケット仮27// catchSocket:ソケット仮28
      this.sktControll.socketEntry("jizenRecommendSubscribe",this.onPayments);

      this.sktControll.socketEntry("doTenkenSubscribe",this.onPayments); // catchSocket:13するしない後日編集
      this.sktControll.socketEntry("inspectSeibiSubscribe",this.onPayments); // catchSocket:ソケット仮06

      // catchSocket:17車検検査費用と車検基本費用の編集
      this.sktControll.socketEntry("kensaHiyouSubscription",this.onPayments, true);

      this.sktControll.socketEntry("shohiyouSubscriptionComp",this.onPayments, true); // catchSocket:15車検諸費用の編集

      // catchSocket:29車検項目の表示順並び替え
      this.sktControll.socketEntry("jizenDisplayOrderSubscription",this.onPayments);
    }
    this.sktControll.connectSocket();
  }

  // created() {
  // }

  // mounted() {
  // }

  createdExtends() {
    // ライフサイクルフックはExtendsの両方で動作するので
    // 別の動作が必要な部分はここで処理を行う

    this.reqService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();

    // this.isUserMode = true;
    // this.isModeTab = true;
    
    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );

    this.connectSocket();

    const userService = new UserService();
    userService.getAllData();
  }

  mountedExtends() {
    // ライフサイクルフックはExtendsの両方で動作するので
    // 別の動作が必要な部分はここで処理を行う
  }

  showDialogInspectionCostOpened() {
    // 車検費用モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    if (this.execAfOpenShowTax) {
      this.$refs.estimateInspectionCostComponent.showTaxDialog();
      this.execAfOpenShowTax = false;
    }
    if ( this.execAfOpenUpdateShohiyou 
      && typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
      this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
      this.execAfOpenUpdateShohiyou = false;
    }
  }

  showDialogEstimateListOpened() {
    // おすすめ整備モーダルの初回呼出表示までにrefしていた内容は実行されないのでここで処理する
    if ( this.execAfOpenUpdateEstimate 
      && typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
      this.$refs.estimateListComponent.updateCurrentData();
      this.execAfOpenUpdateEstimate= true;
    }
  }
  
  socketShohiyouRollback(frame: any) {
    // ユーザー側かネクステージの時有効 →import時に判定済み
    // 複数のソケット通信をしているので処理をまとめる
    this.onReloadShouhiyou(frame);
    if (this.isCanJizenMitsumori) {
      this.onPaymentsBeforeRouteCheck(frame);
    }
  }

  showTaxDialog() {
    this.execAfOpenShowTax = true; // 小窓展開を予約
    this.showDialogInspectionCost = true;
    // setTimeout(() => {
    //  this.$refs.estimateInspectionCostComponent.showTaxDialog();
    // }, 500);
  }
  
//  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
//  sumPrice!: (inspectType: number) => any;
//  @Getter("listInspectByType", { namespace: "InspectSeibi" })
//  listInspect!: (inspectType: number) => SeibiItem[];
  @Getter("currentState", { namespace: "Shohiyou" })
  costData: ShakenShohiyou;
  @Getter("total", { namespace: "Coupon" })
  couponData: any;
  @Getter("total", { namespace: "Option" })
  optionData: any;
  listPrefectures: any = {};
  companyInfo: any = {};
  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogOption: boolean = false;
  showDialogPreview: boolean = false;

  get calcTotal2() {
    let total = 0;
    this.seibiList.forEach((elm: any) => {
        let itemTotal = this.sumItem(elm);
        total += itemTotal;
    });
    return total;
  }
  
  get couponKn() {
    if (this.isExcludingTax) {
      return this.data.couponZn;
    } else {
      return this.data.couponZk;
    }
  }

  get optionKn() {
    if (this.isExcludingTax) {
      return this.data.optionZn;
    } else {
      return this.data.optionZk;
    }
  }
  
  get shakenTotal() {
    /** 2021-08-23 sh #7361 change grandTotal from calculate to reference. [START] */
    /**
     * return (
     *   this.shouhiyou.kensaHiyou.subTotalZk +
     *   this.shouhiyou.houteiHiyou.zeiJibaisekiZk +
     *   this.shouhiyou.houteiHiyou.zeiWeightTax +
     *   this.shouhiyou.houteiHiyou.zeiInshidaiZk +
     *   this.shouhiyou.shakenHiyou.subTotalKazeiZk +
     *   this.shouhiyou.shakenHiyou.subTotalHikazeiZk +
     *   this.optionKn + this.couponKn + this.calcTotal2
     * );
     */
    return this.data.calcTotal;
    /** 2021-08-23 sh #7361 change grandTotal from calculate to reference. [END] */
  }

  onShowDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = true;
  }

  setSeibiData() {
    this.estData.forEach((element: any) => {
      if (element.osusume) {
        if (element.recommend && element.recommend.length > 0) {
          element.recommend.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      } else {
        if (element.subItems && element.subItems.length > 0) {
          element.subItems.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      }
    });
  }

  onCloseDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = false;
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  get dispJibaiseki() {
   return this.data.zeiJibaisekiZk;
  }
  get dispWeightTax() {
   return this.data.zeiWeightTax;
  }
  get dispInshidai() {
   return this.data.zeiInshidaiZk;
  }
  get dispTechInfoAmount() {
   return this.data.zeiTechInfoAmountZk;
  }

  get dispkensaHiyou() {
    return this.data.kensaHiyou;
  }

  dispShakenHiyouList(kazei: boolean) {
    if (this.data.shakenHiyouItems) {
      if (kazei) {
        return this.data.shakenHiyouKazeiItems;
      } else {
        return this.data.shakenHiyouHikazeiItems;
      }
    } else {
      return []; // 空配列
    }
  }

  sumItem(item: any) {
    /** 2023-10-19 invoice [START] */
    return this.isExcludingTax? (item.buhinEditTotalZn || 0) + ( item.kouchinEditZn || 0) 
      : (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
    /** 2023-10-19 invoice [END] */
  }

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [START] */
  onReloadShouhiyou(frame: any) {
    const body = this.utils.getWSData(frame);
    if (body.shakenShuruiSeibiMenuCd) {
      this.inspectionDetailStoreService1.setSeibiMenuCd(body.shakenShuruiSeibiMenuCd);
      this.$notify.info({
        title: "Info",
        message: this.isNextageCustom ? MESSAGE.UpdatedShakenCouseNex :
          (this.ippanSeibiService.isIppanSeibi ? MESSAGE.UpdatedShakenCouseIppanSeibi : MESSAGE.UpdatedShakenCouse)
      });
    }
  }

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [END] */
  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if (res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  getJizenMitsumoriPreview() {
    this.reqService.getJizenMitsumoriPreview(this.uketsukeExtendsId).then(
      (res: any) => {
        let shakenHiyouKazeiItem = [];
        let shakenHiyouHikazeiItem = [];
        // ネクステージ版では課税区分で分岐。通常は全部課税用のエリアに表示する
        if (res.shakenHiyouItems) {
          shakenHiyouKazeiItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '' 
            && ( !this.isNextageCustom || ( this.isNextageCustom && item.kazeiKbn == '1' ));
          });
          shakenHiyouHikazeiItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '' && this.isNextageCustom && item.kazeiKbn == '2';
          });
        }
        res.shakenHiyouKazeiItems = shakenHiyouKazeiItem;
        res.shakenHiyouHikazeiItems = shakenHiyouHikazeiItem;
        /*res.shakenHiyouKazeiItems = [];
        res.shakenHiyouHikazeiItems = [];*/
        /** 2021-08-24 sh #7361 fix bug. it does not reactive. [START] */
        // this.data = res;
        this.$set(this, "data", []);
        this.$set(this, "data", res);
        if (this.$refs.estimateInspectionCostComponent) {
          if ( typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
            this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
          }
        } else {
          this.execAfOpenUpdateShohiyou = true; // 諸費用数値更新を予約
        }
        /** 2021-08-24 sh #7361 fix bug. it does not reactive. [END] */


      },
      (err: any) => {
      }
    );
  }

  getJizenResult() {
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.setLoadingShakenShurui(true);
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    this.reqService.getJizenResult(this.uketsukeExtendsId).then(
      (res: any) => {
        this.estIssueAt = res.estIssueAt;
        this.estData = res.jizenResult;
        if (this.estData && this.estData.length > 0) {
          if (this.estData[0].osusume) {
            this.inspectType = INSPECT_TYPE.RECOMMEND;
          } else {
            this.inspectType = INSPECT_TYPE.LEGAL56;
          }
          this.setSeibiData();
          /** 2021-08-20 sh #7356  send message to customer-screen. [START] */
          if (this.isCanJizenMitsumori) {
            if ( this.$refs.estimateListComponent ) {
              if ( typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
                this.$refs.estimateListComponent.updateCurrentData();
              }
            } else {
              this.execAfOpenUpdateEstimate= true;
            }
          }
          /** 2021-08-20 sh #7356  send message to customer-screen. [END] */
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
          /** する・しない・後日を押した場合、データを取得しなおしているので、子画面が開いていたら、スクロールさせる */
          if (this.showDialogEstimate) {
            this.$refs.estimateListComponent.scrollToCurrentIndex();
          }
          /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
        }
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.setLoadingShakenShurui(false);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
      },
      (err: any) => {
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.setLoadingShakenShurui(false);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
      }
    );
  }

  tesdt(item: any) {
    console.log("mode",item.buhinListDisp);
    item.buhinListDisp = !item.buhinListDisp;
    this.$forceUpdate();
  }

  getJizenInspectionSeibi() {
    this.reqService.getJizenInspectionSeibi(this.uketsukeExtendsId).then(
      (res: any) => {
        this.seibiList = res; // これで受け取り

        // 部品リストを追加する
        if (this.isEstimateBuhin) {
          this.seibiList.forEach((elm: any) => {
            elm.buhinListDisp = false; // 開く閉じるの初期値
            elm.buhinListLoaded = false;
            elm.buhinList = [];
            if ( elm.sknInspectSeibiId != null ) {
              // this.uketsukeExtendsId は e.sknUketsukeExtendsIdで代用可能
              this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, elm.sknInspectSeibiId, 1, 2)
              .then(
                (data: any) => {
                  elm.buhinList = data.buhinList;
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                },
                (error: any) => {
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                }
              );
            } else if ( elm.sknUketsukeManualSeibiId != null ) {
              // this.uketsukeExtendsId は e.sknUketsukeExtendsIdで代用可能
              this.reqService.getInspectSeibiAK3_2(this.uketsukeExtendsId, elm.sknUketsukeManualSeibiId, 1, 3)
              .then(
                (data: any) => {
                  elm.buhinList = data.buhinList;
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                },
                (error: any) => {
                  elm.buhinListLoaded = true;
                  this.$forceUpdate();
                }
              );
            }
          });
        } else {
          // 機能を使わない
          this.seibiList.map((e: any, index: number) => {
            e.buhinListDisp = false; // 開く閉じるの初期値
            e.buhinListLoaded = true;
            e.buhinList = [];
            return e;
          });
        }
      },
      (err: any) => {
      }
    );
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onCloseDialogInspectionCost() {
    this.$refs.estimateInspectionCostComponent.onConfirm();
    this.getJizenMitsumoriPreview();
    this.showDialogInspectionCost = false;
  }

  onShowDialogCoupon() {
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [START] */
    // 調整値引額の基準金額はユーザー側機能で共通化しているが、
    // 工場側では金額系が個別実装で必要な情報のロードを行わないので最新でない場合がある
    
    // 条件：ネクステージで工場側の動作で表示しており、合計金額が違う状態でクーポンをモーダル呼び出しする時
    // モーダル呼び出し関数内でチェックスキップ。合計金額の誤差チェックは税込表示時に時間がかかるので未実装
    if ( !this.isUserMode && this.isNextageCustom ) {
      const userService = new UserService();
      userService.getAllData();
    }
    /** 2024-09-26 ネクステージ用調整値引額機能の工場側動作補助 [END] */
    this.showDialogCoupon = true;
  }

  onCloseDialogCoupon() {
    this.$refs.quickCouponComponent.onConfirm(1);
  }

  onCloseDialogCouponNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogCoupon = false;
  }

  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    if ( !this.isNextageCustom ) {
      this.$refs.quickOptionComponent.onConfirm(1);
    } else {
      this.$refs.quickOptionComponentNex.onConfirm(1);
    }
  }

  onCloseDialogOptionNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogOption = false;
  }

  onShowPrintJizenMitsumori() {
    this.showDialogPreview = true;
  }

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  onPrintJizenMitsumori() {
    this.loadingService.show();
    this.reqService.getSknEstimate(this.uketsukeExtendsId).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      // 2021-11-10 sh #7536 change name from 車検見積結果 to 概算車検見積書
      link.download = this.ippanSeibiService.getIppanSeibiLabel('概算車検見積書') + '.pdf'; 
      link.click();
    });
  }

  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [START] */
  onPayments() {
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    // this.$notify.info({
    //  title: "Info",
    //  message: MESSAGE.UpdatedJizenEstimate
    // });
    // this.getJizenMitsumoriPreview();
    // this.getJizenResult();
    // this.getJizenInspectionSeibi();
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedJizenEstimate
      });
      this.getJizenMitsumoriPreview();
      this.getJizenResult();
      this.getJizenInspectionSeibi();
    }, 1500);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  }
  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [END] */

  onSubmit() {
    // デザイン統合用のダミー
  }

  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateCoupon() {
    const userService = new UserService();
    userService.getCoupon();
  }
  onUpdateOption() {
    const userService = new UserService();
    userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  checkIsCanJizen() {
    if (!this.isUserMode && this.isNextageCustom) {
      // ネクステージ工場画面は許可
      return true;
    }
    return this.isCanJizenMitsumori && this.inspectionDetailStoreService2.isDoJizen;
  }

  isCourseSubItem(item: any) {
    // クイック見積もりと統合するためのダミー
    return "";
  }

  /** 2021-10-05 sh #7438 implements tech info amount. [START] */
  get isUseTechInfoAmount() {
    return this.data.isUseTechInfoAmount == 1;
  }
  /** 2021-10-05 sh #7438 implements tech info amount. [END] */

  /** 2021-10-25 sh #7493 change display of spec. [START] */
  isNotRecommend(item: any) {
    return !(item.sknInspectId == null);
  }
  /** 2021-10-25 sh #7493 change display of spec. [END] */

  isHoan(item: any) {
    if ( !item.isDiscount && !item.isHoanKijun ) {
      return 0;
    } else if ( item.isDiscount && item.isHoanKijun ) {
      return 1;
    } else {
      return 2;
    }
  }

  onConfirmExit() {
    // デザイン統合用のダミー
  }
  
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [START] */
  onPaymentsBeforeRouteCheck(frame: any) {
    const body = this.utils.getWSData(frame);

    if (body.screen && body.screen != this.$route.meta) {
      this.$refs.updateShakenShuruiDialog.onOpen();
    } else {
      this.onPaymentsBeforeSettimeout(4000);
    }
  }

  onPaymentsBeforeSettimeout(msec: number = 1000) {
    setTimeout(() => {
      this.onPayments();
    }, msec);
  }

  setLoadingShakenShurui(b: boolean) {
    // if (this.visibleTabJIzen) {
      this.$set(this, "loading", b);
    // }
  }
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */
}
